import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StoryblokComponent } from 'storyblok-js-client';
import { Components } from '~app/modules/storyblok/constants/storyblok-components';

@Component({
  selector: 'app-column-content-wrapper',
  templateUrl: './column-content-wrapper.component.html',
  styleUrls: ['./column-content-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnContentWrapperComponent {
  @Input() blocks: Array<StoryblokComponent<string>>;
  @Input() _editable: string;

  readonly COMPONENTS = Components;
}
